/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSpecialityVitals } from 'app/entities/speciality-vitals/speciality-vitals.reducer';
import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { getEntities as getLanguages } from 'app/entities/language/language.reducer';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';
import { createEntity, getEntity, reset, updateEntity } from './speciality-vitals.reducer';

export const SpecialityVitalsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const specialityVitals = useAppSelector(state => state.specialityVitals.entities);
  const especialties = useAppSelector(state => state.especialty.entities);
  const languages = useAppSelector(state => state.language.entities);
  const specialityVitalsEntity = useAppSelector(state => state.specialityVitals.entity);
  const loading = useAppSelector(state => state.specialityVitals.loading);
  const updating = useAppSelector(state => state.specialityVitals.updating);
  const updateSuccess = useAppSelector(state => state.specialityVitals.updateSuccess);
  const entityTypeValues = Object.keys(EntityType);

  const handleClose = () => {
    navigate(`/speciality-vitals${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSpecialityVitals({}));
    dispatch(getEspecialties({}));
    dispatch(getLanguages({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.sortOrder !== undefined && typeof values.sortOrder !== 'number') {
      values.sortOrder = Number(values.sortOrder);
    }

    const entity = {
      ...specialityVitalsEntity,
      ...values,
      parent: specialityVitals.find(it => it.id.toString() === values.parent?.toString()),
      specialty: especialties.find(it => it.id.toString() === values.specialty?.toString()),
      language: languages.find(it => it.id.toString() === values.language?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          entityType: 'LAB',
          ...specialityVitalsEntity,
          parent: specialityVitalsEntity?.parent?.id,
          specialty: specialityVitalsEntity?.specialty?.id,
          language: specialityVitalsEntity?.language?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.specialityVitals.home.createOrEditLabel" data-cy="SpecialityVitalsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.specialityVitals.home.createOrEditLabel">Create or edit a SpecialityVitals</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="speciality-vitals-id"
                  label={translate('tinyMedicRestApp.specialityVitals.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.active')}
                id="speciality-vitals-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.lastUpdated')}
                id="speciality-vitals-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.timestampEntry')}
                id="speciality-vitals-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.microSec')}
                id="speciality-vitals-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.cursor')}
                id="speciality-vitals-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.title')}
                id="speciality-vitals-title"
                name="title"
                data-cy="title"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.unitsOfMeasure')}
                id="speciality-vitals-unitsOfMeasure"
                name="unitsOfMeasure"
                data-cy="unitsOfMeasure"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.valueType')}
                id="speciality-vitals-valueType"
                name="valueType"
                data-cy="valueType"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.normalRangeLowerLimit')}
                id="speciality-vitals-normalRangeLowerLimit"
                name="normalRangeLowerLimit"
                data-cy="normalRangeLowerLimit"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.normalRangeUpperLimit')}
                id="speciality-vitals-normalRangeUpperLimit"
                name="normalRangeUpperLimit"
                data-cy="normalRangeUpperLimit"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.possibleRangeLowerLimit')}
                id="speciality-vitals-possibleRangeLowerLimit"
                name="possibleRangeLowerLimit"
                data-cy="possibleRangeLowerLimit"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.possibleRangeUpperLimit')}
                id="speciality-vitals-possibleRangeUpperLimit"
                name="possibleRangeUpperLimit"
                data-cy="possibleRangeUpperLimit"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.symptom')}
                id="speciality-vitals-symptom"
                name="symptom"
                data-cy="symptom"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.subSpeciality')}
                id="speciality-vitals-subSpeciality"
                name="subSpeciality"
                data-cy="subSpeciality"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.group')}
                id="speciality-vitals-group"
                name="group"
                data-cy="group"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.forAppointment')}
                id="speciality-vitals-forAppointment"
                name="forAppointment"
                data-cy="forAppointment"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.forPrescription')}
                id="speciality-vitals-forPrescription"
                name="forPrescription"
                data-cy="forPrescription"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.subGroup')}
                id="speciality-vitals-subGroup"
                name="subGroup"
                data-cy="subGroup"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.country')}
                id="speciality-vitals-country"
                name="country"
                data-cy="country"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.sortOrder')}
                id="speciality-vitals-sortOrder"
                name="sortOrder"
                data-cy="sortOrder"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.groupOnly')}
                id="speciality-vitals-groupOnly"
                name="groupOnly"
                data-cy="groupOnly"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.vitalCode')}
                id="speciality-vitals-vitalCode"
                name="vitalCode"
                data-cy="vitalCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.config')}
                id="speciality-vitals-config"
                name="config"
                data-cy="config"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.entityType')}
                id="speciality-vitals-entityType"
                name="entityType"
                data-cy="entityType"
                type="select"
              >
                {entityTypeValues.map(entityType => (
                  <option value={entityType} key={entityType}>
                    {translate(`tinyMedicRestApp.EntityType.${entityType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.specialityVitals.entityId')}
                id="speciality-vitals-entityId"
                name="entityId"
                data-cy="entityId"
                type="text"
              />
              <ValidatedField
                id="speciality-vitals-parent"
                name="parent"
                data-cy="parent"
                label={translate('tinyMedicRestApp.specialityVitals.parent')}
                type="select"
              >
                <option value="" key="0" />
                {specialityVitals
                  ? specialityVitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="speciality-vitals-specialty"
                name="specialty"
                data-cy="specialty"
                label={translate('tinyMedicRestApp.specialityVitals.specialty')}
                type="select"
                required
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="speciality-vitals-language"
                name="language"
                data-cy="language"
                label={translate('tinyMedicRestApp.specialityVitals.language')}
                type="select"
              >
                <option value="" key="0" />
                {languages
                  ? languages.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/speciality-vitals" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SpecialityVitalsUpdate;
